/**
 * 处理 cos 返回的 ACl 数据
 */
const CONSTANT = {
  userAclMap: window.lang.t('cos.user_acl_map'),
};

const utils = {
  /**
   * 从权限信息对象中提取第一个UIN
   * @param {*} obj 权限信息对象
   *    - ID 存储桶持有者的完整 ID
   */
  getAclUin(obj) {
    if (obj.ID) {
      if (obj.ID.indexOf(':uin/') !== -1) {
        return obj.ID.split(':uin/')[1];
      }
      return 'anyone';
    }
    if (obj.URI) {
      return 'anyone';
    }
    return '';
  },
  /**
   * 从权限信息对象中提取第二个UIN
   * @param {*} obj 权限信息对象
   *    - ID 存储桶持有者的完整 ID
   */
  getAclSubaccount(obj) {
    if (obj.ID) {
      if (obj.ID.indexOf(':uin/') !== -1) {
        return obj.ID.split(':uin/')[2];
      }
      return 'anyone';
    }
    if (obj.URI) {
      return 'anyone';
    }
    return '';
  },
  getAcl(Grants) {
    const publicAcl = {
      read: false,
      write: false,
    };
    let acl = '';
    Grants.forEach(item => {
      const uin = item.Grantee && this.getAclUin(item.Grantee);
      if (uin === 'anyone' && item.Permission === 'READ') {
        publicAcl.read = true;
      } else if (uin === 'anyone' && item.Permission === 'WRITE') {
        publicAcl.write = true;
      } else if (uin === 'anyone' && item.Permission === 'FULL_CONTROL') {
        publicAcl.read = true;
        publicAcl.write = true;
      }
    });

    if (publicAcl.read && publicAcl.write) {
      acl = 'public-read-write';
    } else if (publicAcl.read && !publicAcl.write) {
      acl = 'public-read';
    } else {
      acl = 'private';
    }

    return acl;
  },
  getUserAcl(Grants) {
    const userAcl = {};
    let rootUin;
    let subUin;

    Grants.forEach(item => {
      rootUin = item.Grantee && this.getAclUin(item.Grantee);
      subUin = item.Grantee && this.getAclSubaccount(item.Grantee);

      if (rootUin === 'anyone') {
        return;
      }

      if (rootUin !== subUin) {
        rootUin += `/${subUin}`;
      }
      userAcl[rootUin] = userAcl[rootUin] || [];

      // 对于已经是FULL_CONTROL的用户而且重复添加的，只显示FULL_CONTROL
      if (userAcl[rootUin][0] === 'FULL_CONTROL') {
        return;
      }

      if (item.Permission === 'FULL_CONTROL') {
        userAcl[rootUin] = ['FULL_CONTROL'];
      } else {
        userAcl[rootUin].push(item.Permission);
      }
    });

    return userAcl;
  },
  getUserAclStr(acl) {
    const res = [];

    if (acl.length === 1) {
      res.push(CONSTANT.userAclMap[acl[0]]);
    } else {
      acl.forEach(aclItem => {
        res.push(CONSTANT.userAclMap[aclItem]);
      });
    }

    return res.join('、');
  },
  fixedAclData(aclData) {
    const owner = this.getAclUin(aclData.Owner);
    const uin = owner;
    const publicAcl = aclData.ACL || 'private';
    const userAclList = [];

    let rootUin;
    let subUin;
    let needAddOwner = true;
    const cacheUser = {};

    if (aclData && aclData.Grants) {
      const userAcl = this.getUserAcl(aclData.Grants);

      aclData.Grants.forEach(item => {
        rootUin = this.getAclUin(item.Grantee);
        subUin = this.getAclSubaccount(item.Grantee);

        if (rootUin !== 'anyone') {
          if (subUin !== rootUin) {
            rootUin += `/${subUin}`;
            if (cacheUser[rootUin]) {
              return;
            }
            cacheUser[rootUin] = true;

            userAclList.push({
              uin: rootUin,
              rootable: false,
              acl: userAcl[rootUin],
              mainer: false,
            });
          } else {
            if (cacheUser[rootUin]) {
              return;
            }
            cacheUser[rootUin] = true;

            userAclList.push({
              uin: rootUin,
              rootable: true,
              acl: userAcl[rootUin],
              mainer: false,
            });
          }

          if (rootUin === subUin && subUin === owner && item.Permission === 'FULL_CONTROL') {
            needAddOwner = false;
          }
        }
      });
    }

    // 如果设置过acl，则不会返回自己，则把自己那条加上
    // 这里排除用户自己设置了自己为full_control的情况
    if (needAddOwner) {
      userAclList.unshift({
        uin: owner,
        rootable: true,
        acl: ['FULL_CONTROL'],
        mainer: true,
      });
    } else {
      userAclList[0].mainer = true;
    }

    return {
      uin,
      publicAcl,
      userAclList,
    };
  },
};

const api = {
  init(aclData) {
    if (aclData.Owner) {
      const data = utils.fixedAclData(aclData);
      const { userAclList } = data;
      userAclList.forEach(item => {
        item.showAcl = utils.getUserAclStr(item.acl);
        item.editable = false;
        item.editUser = null;
      });
      return data;
    }
    return { publicAcl: aclData.ACL };
  },
  testUin(uin) {
    if (!/^[0-9]{5,}$/.test(uin)) {
      return false;
    }
    return true;
  },
  getUserAclStr: utils.getUserAclStr,
  getParameter(aclList) {
    const rtnItem = {
      ReadUinList: '',
      WriteUinList: '',
      ReadAcpUinList: '',
      WriteAcpUinList: '',
      FullUinList: '',
    };

    const ownerUin = aclList[0].uin;

    aclList.forEach(item => {
      item.acl.forEach(aclItem => {
        const { rootable } = item;
        const id = rootable
          ? `id="qcs::cam::uin/${item.uin}:uin/${item.uin}"`
          : `id="qcs::cam::uin/${ownerUin}:uin/${item.uin.split('/')[1]}"`;
        if (aclItem === 'FULL_CONTROL') {
          if (item.uin !== ownerUin) {
            rtnItem.FullUinList = rtnItem.FullUinList ? `${rtnItem.FullUinList},${id}` : `${id}`;
          }
        } else if (aclItem === 'READ') {
          rtnItem.ReadUinList = rtnItem.ReadUinList ? `${rtnItem.ReadUinList},${id}` : `${id}`;
        } else if (aclItem === 'WRITE') {
          rtnItem.WriteUinList = rtnItem.WriteUinList ? `${rtnItem.WriteUinList},${id}` : `${id}`;
        } else if (aclItem === 'READ_ACP') {
          rtnItem.ReadAcpUinList = rtnItem.ReadAcpUinList ? `${rtnItem.ReadAcpUinList},${id}` : `${id}`;
        } else if (aclItem === 'WRITE_ACP') {
          rtnItem.WriteAcpUinList = rtnItem.WriteAcpUinList ? `${rtnItem.WriteAcpUinList},${id}` : `${id}`;
        }
      });
    });
    return rtnItem;
  },
};

export default api;
